<fui-inline-fascia [disabled]="disabled || readonly" (focussed$)="focus()">
    <fui-fixtures>
        <fui-fixture>
            <fui-checkbox-dom [disabled]="disabled" [readonly]="readonly"
                              [focussed]="focussed" [hovered]="hovered" [valued]="valued" (click)="click()">
                <input (blur)="onBlur($event)" [disabled]="disabled || readonly" (focus)="onFocus($event)" [id]="name"
                       #input [name]="name"
                       [(ngModel)]="value" [tabindex]="tabindex" type="checkbox">
            </fui-checkbox-dom>
        </fui-fixture>
    </fui-fixtures>
</fui-inline-fascia>
